import {
  FiltroDistribuicaoVarietal,
  FiltroConcentracaoColheita,
  FiltroProdutividade,
  FiltroOperacoesExecutadas,
  FiltroNumeroDeAplicacoes,
  FiltroIdadeDoTalhao,
} from "core/features/maps/typings";

export const getNumberOfAdvancedFiltersDistribuicaoVarietal = (
  actualFilter: FiltroDistribuicaoVarietal
) => {
  if (actualFilter) {
    const {
      periodoPlantio,
      periodoColheita,
      periodoPrevisaoDeColheita,
      periodoEmergencia,
      safraPeriodos,
    } = actualFilter;

    const periodoPlantioCount =
      periodoPlantio?.dataInicial || periodoPlantio?.dataFinal ? 1 : 0;

    const periodoColheitaCount =
      periodoColheita?.dataInicial || periodoColheita?.dataFinal ? 1 : 0;

    const periodoPrevisaoDeColheitaCount =
      periodoPrevisaoDeColheita?.dataInicial ||
      periodoPrevisaoDeColheita?.dataFinal
        ? 1
        : 0;
    const periodoEmergenciaCount =
      periodoEmergencia?.dataInicial || periodoEmergencia?.dataFinal ? 1 : 0;

    const safraPeriodosCount = safraPeriodos && safraPeriodos?.length > 0 ? 1 : 0;

    return (
      periodoPlantioCount +
      periodoColheitaCount +
      periodoPrevisaoDeColheitaCount +
      periodoEmergenciaCount +
      safraPeriodosCount
    );
  }
  return 0;
};

export const getNumberOfAdvancedFiltersConcentracaoColheita = (
  actualFilter: FiltroConcentracaoColheita
) => {
  if (actualFilter) {
    const {
      safraPeriodos,
    } = actualFilter;

    const safraPeriodosCount = safraPeriodos && safraPeriodos?.length > 0 ? 1 : 0;

    return (
      safraPeriodosCount
    );
  }
  return 0;
};

export const getNumberOfAdvancedFiltersProdutividade = (
  actualFilter: FiltroProdutividade
) => {
  if (actualFilter) {
    const {
      safraPeriodos,
    } = actualFilter;

    const safraPeriodosCount = safraPeriodos && safraPeriodos?.length > 0 ? 1 : 0;

    return (
      safraPeriodosCount
    );
  }
  return 0;
};

export const getNumberOfAdvancedFiltersOperacoesExecutadas = (
  actualFilter: FiltroOperacoesExecutadas
) => {
  if (actualFilter) {
    const { equipeIds, insumos, periodoOperacao } = actualFilter;

    const periodoOperacaoCount =
      periodoOperacao?.dataInicial || periodoOperacao?.dataFinal ? 1 : 0;

    const insumosCount = insumos && insumos.length > 0 ? 1 : 0;

    const equipesIdCount = equipeIds && equipeIds.length > 0 ? 1 : 0;

    return periodoOperacaoCount + insumosCount + equipesIdCount;
  }
  return 0;
};

export const getNumberOfAdvancedFiltersNumeroAplicacoes = (
  actualFilter: FiltroNumeroDeAplicacoes
) => {
  if (actualFilter) {
    const {
      safraPeriodos,
    } = actualFilter;

    const safraPeriodosCount = safraPeriodos && safraPeriodos?.length > 0 ? 1 : 0;

    return (
      safraPeriodosCount
    );
  }
  return 0;
};

export const getNumberOfAdvancedFiltersIdadeTalhao = (
  actualFilter: FiltroIdadeDoTalhao
) => {
  if (actualFilter) {
    const {
      safraPeriodos,
    } = actualFilter;

    const safraPeriodosCount = safraPeriodos && safraPeriodos?.length > 0 ? 1 : 0;

    return (
      safraPeriodosCount
    );
  }
  return 0;
};

export const getIsApplyButtonDisabledOnDistribuicaoVarietal = () => {};
